import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import loader1 from "../../asset/Image/loader1.svg";
import loaderCss from "./Loader.module.css";

export default function Loader() {
  return (
    <>
      <Container className="text-center">
        <Row>
          <Col>
            <img src={loader1} className={`${loaderCss.animation}`} alt="" />
          </Col>
        </Row>
      </Container>
    </>
  );
}
